import { ApplicantDetailBody } from "./ApplicantDetailBody.web";

/**
 * Per-job applicant detail (web). The full implementation now lives in
 * `ApplicantDetailBody.web.tsx` so the company-wide Applications inbox can
 * render the same body inside its master-detail pane; this route-level screen
 * keeps rendering it full-screen exactly as before.
 */
export function EmployerApplicantDetailScreen({
  jobId,
  applicationId,
}: {
  jobId: string;
  applicationId: string;
}) {
  return (
    <ApplicantDetailBody
      jobId={jobId}
      applicationId={applicationId}
      variant="page"
    />
  );
}
